import { METHOD } from "../data";
import Reveal from "../components/Reveal";

export default function Method() {
  return (
    <section id="metodo" className="relative overflow-hidden bg-[#080808] py-24 sm:py-32" data-testid="method-section">
      {/* huge background word */}
      <div className="pointer-events-none absolute -right-10 top-8 select-none font-display text-[22vw] font-black uppercase leading-none text-outline-white opacity-40">
        ÚNICO
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <span className="font-display text-sm font-semibold uppercase tracking-[0.35em] text-[--gold]">
              Método de Treinamento
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              Cada pessoa <br className="hidden sm:block" />é <span className="text-[--gold]">única</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base leading-relaxed text-neutral-300 sm:text-lg">
              Nada de treino de prateleira. O seu programa é construído a partir do seu perfil, da sua
              rotina e da sua meta — e evolui junto com você a cada semana.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 divide-y divide-[--gold]/15 border-t border-[--gold]/15">
          {METHOD.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.08}>
              <div className="group grid grid-cols-1 gap-4 py-8 transition-colors duration-300 hover:bg-white/[0.02] sm:grid-cols-[auto_1fr_2fr] sm:items-center sm:gap-10 sm:px-4">
                <span className="font-display text-5xl font-black text-[--gold]/40 transition-colors duration-300 group-hover:text-[--gold] sm:text-6xl">
                  {m.n}
                </span>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
                  {m.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-neutral-400">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
